import { Select } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../MdmCardFormStore";
import { ZStrOption } from "../types/dataTypes";
import { FormField } from "../types/MdmCardFormTypes";
import { ZCompSelect } from "../types/metaComponent";
import { FieldBox } from "./FieldBox";

interface PropsCardSelect {
  form: MdmCardFormStore;
  field: FormField;
  component: ZCompSelect;
}

export const CardSelect: React.FC<PropsCardSelect> = observer((props) => {
  const { form, field, component } = props;
  const { data, path } = field;
  const opt: ZStrOption | null = data?.type === "strOption" ? data.value : null;

  return (
    <FieldBox field={field} form={form}>
      <Select
        options={component.options ?? []}
        style={{ width: "100%" }}
        value={opt?.value}
        disabled={form.isItemDisabled(field)}
        onChange={(v, o) => {
          // нам нужен второй параметр
          if (!data || data.type === "strOption") {
            // TODO: пока без анализа вариантов значения
            field.setData({
              type: "strOption",
              value: o as ZStrOption,
              name: field.meta.name,
            });
          }
          form.onChange(path);
        }}
      />
    </FieldBox>
  );
});
